import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../core';
import { AddressUtils } from '../utils/address-utils';

@Pipe({
  name: 'address',
  pure: true,
})
export class AddressPipe implements PipeTransform {
  transform(
    address: Address | null | undefined,
    format: string = '[addressLine1, ][addressLine2, ][city, ][stateCode, ][postalCode]',
  ): string {
    return AddressUtils.format(address, format);
  }
}
